import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/api-client";
export type { FullAlignmentNode } from "@/types/entities";

export function useFullAlignment(year?: number, rootPillarId?: string) {
  return useQuery({
    queryKey: ["full-alignment", year, rootPillarId],
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/alignment/full", {
        params: { query: { year, root_pillar_id: rootPillarId } },
      });
      if (error) throw new Error(error.error.message);
      return data;
    },
  });
}
